module.exports = __webpack_public_path__ + "static/avatar_pavel_osipov@2x-d760329ca6fa1917735c1b0617839aa9.jpg";